const commonActionTypes = {
  SET_CONTEXT: 'SET_CONTEXT',

  FETCH_STATIC_DATA: 'FETCH_STATIC_DATA',
  FETCH_STATIC_DATA_SUCCESS: 'FETCH_STATIC_DATA_SUCCESS',
  FETCH_STATIC_DATA_FAIL: 'FETCH_STATIC_DATA_FAIL',

  FETCH_COMPANY_PROFILES_LIST: 'FETCH_COMPANY_PROFILES_LIST',
  FETCH_COMPANY_PROFILES_LIST_SUCCESS: 'FETCH_COMPANY_PROFILES_LIST_SUCCESS',
  FETCH_COMPANY_PROFILES_LIST_FAIL: 'FETCH_COMPANY_PROFILES_LIST_FAIL',

  RESET_COMPANY_PROFILES_LIST: 'RESET_COMPANY_PROFILES_LIST',

  SET_SELECTED_COMPANY_PROFILE: 'SET_SELECTED_COMPANY_PROFILE',
};

export default commonActionTypes;
